import { combineReducers } from 'redux'
import injectReducer from '../../../state/hoc/injectReducer'
import all from './all'

const reducer = combineReducers({
  all
})

export const injector = injectReducer({
  key: 'activities',
  reducer,
  entities: ['activities']
})

export default reducer
